module.exports = __webpack_public_path__ + "static/media/29ADMSPC6.fe7858a9.jpg";